<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler v-show="!!validNutritionist" class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="#">
        <img class="navbar-brand-full" src="../assets/img/lotus.png" width="89" height="25" alt="NutHub Logo">
        <img class="navbar-brand-minimized" src="../assets/img/lotus.png" width="30" height="30" alt="ButHub Logo">
      </b-link>
      <SidebarToggler v-show="!!validNutritionist" class="d-md-down-none" display="lg" :defaultOpen="true" />
      <b-navbar-nav class="ml-auto">
        <b-nav-item v-if="width>991" class="d-md-down-none">
            <select class="form-control" v-model="language" id="exampleFormControlSelect1">
              <option value="en">English</option>
              <option value="iw">עברית</option>
            </select>
        </b-nav-item>
        <b-nav-item v-if="validNutritionist" class="d-md-down-none">
         <router-link to="/calendar"><i class="icon-calendar" style="color: #fff;"></i></router-link>
        </b-nav-item>
        <NotificationsDropdown/>
        <DefaultHeaderDropdownAccnt/>
      </b-navbar-nav>
    </AppHeader>
    <div class="app-body">
      <AppSidebar v-show="!!validNutritionist" fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav v-if="validNutritionist" :navItems="nav"></SidebarNav>
        <SidebarNav v-if="!validNutritionist" :navItems="[]"></SidebarNav>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>
      <main :class="'main '+ routeSlugName">
        <!-- <Breadcrumb :list="list"/> -->
        
        <div class="container-fluid" style="margin-top:20px;">
        <b-row>
          <b-col lg="2" md="3" sm="3" v-show="!!validNutritionist">
            <button type="button" class="btn btn-primary" @click="$router.go(-1)">
              <i class="fa fa-arrow-left"></i> {{$t('back')}}
            </button>
          </b-col>

          <b-col :lg="!validNutritionist ? '10' : '8'" :md="!validNutritionist ? '10' : '8'" :sm="!validNutritionist ? '10' : '7'">
            <b-card v-if="!!link && link.name" :no-body="true" style="border:none;" footer-class="px-3 py-2">
              <b-card-body class="clearfix pt-0">
                <b-row class="text-center">
                  <b-col sm="12" md="12" lg="12" class="justify-content-center" :style="'background-color:'+link.color" >
                    <h4 class="p-2" style="color:#fff;"> {{$t('nav.'+link.name)}} </h4> 
                    <h6 class="p-2" style="color:#fff;" v-if="!!tips[language][link.name]"> {{tips[language][link.name]}} </h6> 
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
          </b-col>

          <b-col v-if="width <= 991" lg="4" md="4" sm="4">
            <select class="form-control" v-model="language" id="exampleFormControlSelect1">
              <option value="en">English</option>
              <option value="iw">עברית</option>
            </select>
          </b-col>
          
        </b-row>
          <router-view style="margin-top:20px;"></router-view>
        </div>
      </main>
      <AppAside fixed>
        <!--aside-->
      </AppAside>
    </div>
    <TheFooter>
      <!--footer-->
      <div>
        <a href="/">NutHub</a>
        <span class="ml-1">&copy; {{ new Date().getFullYear() }} NutHub.</span>
      </div>
      <div class="ml-auto">
        <span class="mr-1">Powered by</span>
        <a href="/">NutHub</a>
      </div>
    </TheFooter>
  </div>
</template>

<script>
import nav from '@/_nav'
import naviw from '@/_naviw'
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt';
import NotificationsDropdown from './NotificationsDropdown';
import Nutritionist from '@/store/ORM/nutritionists.js';
import InfoService from '@/services/info.service.js';

export default {
  name: 'DefaultContainer',
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    NotificationsDropdown
  },
  data () {
    return {
      nav: nav.items,
      links : [
        {
          name: 'account_settings',
          url: '/profile',
          icon: 'icon-settings',
          color: '#FF9800',
          selected:false,
        },
        {
          name: 'orders',
          url: '/orders',
          icon: 'fa fa-dollar',
          color: '#ffe119',
          selected:false,
        },
        {
          name: 'calendar',
          url: '/calendar',
          icon: 'icon-calendar',
          color: '#4363d8',
          selected:false,
        },
        {
          name: 'client_list',
          url: '/nutritionist/clients',
          icon: 'icon-people',
          color: '#911eb4',
          selected:false,
        },
        {
          name: 'send_email',
          url: '/send-email',
          icon: 'fa fa-envelope-o',
          color: '#46f0f0',
          selected:false,
        },
        {
          name: 'all_menus',
          url: '/nutritionist/menus',
          icon: 'icon-layers',          
          color: '#f032e6',
          selected:false,
        },
        {
          name: 'create_menu',
          url: '/nutritionist/create-menu',
          icon: 'icon-layers',
          color: '#bcf60c',
          selected:true,
        },
        {
          name: 'bmi',
          url: '/bmi',
          icon: 'icon-calculator',
          color: '#fabebe',
          selected:false,
        },
        {
          name: 'calculators',
          url: '/calculator',
          icon: 'icon-calculator',
          color: '#008080',
          selected:true,
        },
        {
          name: 'diets',
          url: '/diets',
          icon: 'icon-layers',
          color: '#e6beff',
          selected:true,
        },
        {
          name: 'add_client',
          url: '/nutritionist/clients/add',
          icon: 'icon-user-follow',
          color: '#f58231',
          selected:true,
        },
        {
          name: 'specialists',
          url: '/specialists',
          icon: 'icon-briefcase',
          color: '#9a6324',
          selected:false,
        },
        {
          name: 'shop',
          url: '/shop',
          icon: 'icon-basket-loaded',
          color: '#080808',
          selected:false,
        },

      ],
      link : {},
      tips: { en: [] , iw:[]}
    }
  },
  created(){
    // this.link = this.links[0];

    this.link = this.links.find((el)=> { return el.url == this.$route.path});

    this.$i18n.locale = this.language;
    if(this.language == 'en'){
      this.nav = nav.items;
    }else{
      this.nav = naviw.items;
    }

    if(!this.validNutritionist){
      this.$router.push({ path: '/profile' });
    }

    
    InfoService.getTips().then((res)=>{
      if(res.data.success){
        this.tips = res.data.tips;
      }else{
        alert("ERROR");
      }
    },err => {
      alert("ERROR");
    });
  },
  computed: {
    name () {
      return this.$route.name
    },
    routeSlugName () {
      return this.$route.name.replace(' ','-').toLowerCase();
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label )
    },
    language: {
      get: function() {
        return this.$store.getters['UserModules/getLanguage']
      },
      set: function(newValue) {
        this.$i18n.locale = newValue;
        if(newValue == 'en'){
          this.nav = nav.items;
        }else{
          this.nav = naviw.items;
        }
        this.$store.dispatch('UserModules/SetLanguage', newValue);
      }
      
    },
    width: function() {
      return Math.max(
        document.body.scrollWidth,
        document.documentElement.scrollWidth,
        document.body.offsetWidth,
        document.documentElement.offsetWidth,
        document.documentElement.clientWidth
      );
    },
    validNutritionist: function(){
      let nut = Nutritionist.query().first();
      if(!!nut.address && !!nut.email && !!nut.first_name && !!nut.last_name && !!nut.sex){
        return true;
      }
      return false;
    }
  },
  watch:{
    $route (to, from){
      
        if(!this.validNutritionist && to.name != "Profile"){
          this.$router.push('/profile');
        }
        
        this.link = this.links.find((el)=> { return el.url == to.path});
    }
  } 
}
</script>


<style>
.sidebar{
  background:#004A7F;
}
.sidebar .nav-link.active{
  background:#18669e;
}
.app-body{
  background-color:#FEFEFE;
}
</style>